import React from 'react';
import { css } from "@emotion/core";
import PuffLoader from "react-spinners/PuffLoader";

export default function Loading({
    topSpace = false,
    size = 150,
    progress = undefined
  }: {topSpace?: boolean, size?: number, progress?: any}) {
  const override = css`
    display: flex;
    margin: 0 auto;
  `;
  return (
    <div className="sweet-loading-modal" style={topSpace ? {marginTop: "5rem"} : {}}>
      <PuffLoader
        css={override}
        size={size}
        color={"#62af42"}
        loading={true}
      />
      {progress !== undefined && progress !== -1 ? <div className="sweet-loading-modal-progress">{progress}%</div> : null}
    </div>
  );
}
